// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"320":"2f8ff65b0c7ad2e6","669":"434e667bf7d70f73"}[chunkId] + ".js";
};